<template>
  <TemplateView>
    <div class="container">
      <div class="d-flex flex-wrap mb-8">
        <template v-for="(page, p) in list">
          <BaseButton
            :text="page.text"
            style-type="chip"
            :key="'settingTemplate' + p"
            :disabled="$route.name === page.toName || $route.name === page.toName + 'Edit'"
            @click="$router.push({ name: page.toName })"
          />
        </template>
      </div>
      <router-view />
    </div>
  </TemplateView>
</template>

<script>
export default {
  name: 'settingTemplate',
  computed: {
    list() {
      return [
        {
          toName: 'SettingOfferTemplate',
          text: this.localStorage.translations.pages.projects_status.status.tsenopredlozhenie,
          if: this.$userCheckAccess({
            abilities: 'edit_default_content_settings',
          }),
        },
        {
          toName: 'SettingLetter',
          text: this.localStorage.translations.pages.sales_project['price_offer_terms-labels']['offer_letter'],
          if: this.$userCheckAccess({
            abilities: 'edit_default_content_settings',
          }),
        },
      ]
    },
  },
  mounted() {
    const findReadyPage = this.list.find((i) => i.if)
    this.$router.replace({ name: findReadyPage ? findReadyPage.toName : 'Home' })
  },
}
</script>

<style scoped lang="scss">
.flex-wrap {
  gap: 20px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    gap: 12px;
  }
}
</style>